import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/assets/scss/components/_input.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import { Injecss } from '../../packages/injecss/injecss.js';
import Label from '../label/label.js';
import Spinner from '../spinner/spinner.js';
import Icon from '../icon/icon.js';

var Input = function Input(_ref) {
  var active = _ref.active,
      disabled = _ref.disabled,
      extraClasses = _ref.extraClasses,
      infoError = _ref.infoError,
      label = _ref.label,
      InlineIcon = _ref.InlineIcon,
      info = _ref.info,
      loading = _ref.loading,
      id = _ref.id,
      requiredText = _ref.requiredText,
      type = _ref.type,
      valid = _ref.valid,
      inlineLabel = _ref.inlineLabel,
      rest = _objectWithoutProperties(_ref, ["active", "disabled", "extraClasses", "infoError", "label", "InlineIcon", "info", "loading", "id", "requiredText", "type", "valid", "inlineLabel"]);

  // defines base block class name for the input
  var bem = HoneyBem('input', styles); // stores BEM class names, defines BEM modifiers

  var inputClassNames = bem.b({
    valid: valid === true,
    error: valid === false,
    disabled: disabled,
    active: active,
    'has-icon': InlineIcon,
    'no-label': !label,
    'has-inline-label': inlineLabel
  });
  return React.createElement("div", {
    className: inputClassNames
  }, label && React.createElement(Label, {
    extraClasses: bem.e('label'),
    labelFor: id,
    requiredText: requiredText,
    text: label
  }), React.createElement("input", _extends({
    id: id,
    disabled: disabled,
    required: requiredText ? true : _objectSpread2({}, rest).required,
    type: type,
    className: bem.e('field', false, extraClasses)
  }, rest)), loading && React.createElement(Spinner, {
    size: "sm",
    extraClasses: bem.e('spinner')
  }), InlineIcon && React.createElement(Icon, {
    InlineIcon: InlineIcon,
    extraClasses: bem.e('icon')
  }), valid === false && infoError && React.createElement("span", {
    className: bem.e('info')
  }, infoError), info && React.createElement("span", {
    className: bem.e('info')
  }, info), inlineLabel && React.createElement("span", {
    className: bem.e('inline-label')
  }, inlineLabel));
};
Input.displayName = 'Input';
Input.defaultProps = {
  active: null,
  disabled: null,
  extraClasses: '',
  InlineIcon: null,
  loading: false,
  info: null,
  infoError: null,
  requiredText: null,
  type: 'text',
  valid: null,
  inlineLabel: null
};
Input.propTypes = {
  /** Triggers element visual active state */
  active: PropTypes.bool,

  /** Disables the input if set */
  disabled: PropTypes.bool,

  /** Custom classes name for input element */
  extraClasses: PropTypes.string,

  /** Provides label text, required if aria-label is not passed */

  /* eslint-disable react/require-default-props */
  // we want label to be always checked against
  label: function label(_ref2) {
    var ariaLabel = _ref2['aria-label'],
        _label = _ref2.label;
    // if no aria label nor label throw validation error
    return !ariaLabel && !_label ? new Error('Either label or aria label are required') : null;
  },

  /** Provides extra information for this input field */
  info: PropTypes.string,

  /** Provides extra information for an error, gets displayed only when `valid` is set to false */
  infoError: PropTypes.string,

  /** Icon to be showed in the input field, needs to be an svg inline icon component */
  InlineIcon: PropTypes.func,

  /** Defines element ID that is used to bind it to the label, required if label is present */
  id: function id(_ref3) {
    var _id = _ref3.id,
        label = _ref3.label;
    // if no id but label is provided throw a validation error
    return !_id && label ? new Error('id is required if label is used') : null;
  },

  /** Displays loading spinner inside input field */
  loading: PropTypes.bool,

  /** Marks the element as required, adds specified text to label text,
  * e.g. Phone (Mandatory) for required="(Mandatory)" */
  requiredText: PropTypes.string,

  /** Sets HTML input type */
  type: PropTypes.oneOf(['text', 'password', 'search', 'email', 'tel', 'time', 'url', 'number']),

  /** Triggers visual validation output */
  valid: PropTypes.bool,

  /** text to show in an inline label */
  inlineLabel: PropTypes.string
};
var Input$1 = Injecss(Input, styles);

export default Input$1;
export { Input };
